"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.MprStatement = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  '&:empty': {
    display: 'none'
  }
}));
const MprStatement = exports.MprStatement = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary
}));
//# sourceMappingURL=styles.js.map